// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FR0yYushxpskz6O5b4Gi{width:100%;height:100%;display:flex;flex-direction:column}.FR0yYushxpskz6O5b4Gi .CStXPhKxDrF8RWqDo7G9{color:var(--color-primary);text-align:center;font-size:1.1666666667rem;font-style:normal;font-weight:700;line-height:116.5%;margin:0 0 10px}.FR0yYushxpskz6O5b4Gi .rtcKKdeFYcFu2rLnaEB3{border-radius:10px;overflow:hidden;position:relative;flex:1 0 0;background-repeat:no-repeat;background-position:center}.FR0yYushxpskz6O5b4Gi .rtcKKdeFYcFu2rLnaEB3 .J07wM2TYbKyS4XI2gVQh{position:absolute;max-width:100%;max-height:100%;top:0;left:0;right:0;bottom:0;margin:auto}.FR0yYushxpskz6O5b4Gi .Uum0rT1sE66E5rDVf6Bd{text-align:center;flex:0 0 auto;padding:0.8333333333rem;font-size:0.8333333333rem;max-width:1100px;margin:0 auto;color:var(--color-sa-gray)}.FR0yYushxpskz6O5b4Gi .Uum0rT1sE66E5rDVf6Bd a{color:inherit;font-weight:bold}.FR0yYushxpskz6O5b4Gi .Uum0rT1sE66E5rDVf6Bd a:hover{color:var(--color-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `FR0yYushxpskz6O5b4Gi`,
	"header": `CStXPhKxDrF8RWqDo7G9`,
	"contentWrapper": `rtcKKdeFYcFu2rLnaEB3`,
	"content": `J07wM2TYbKyS4XI2gVQh`,
	"description": `Uum0rT1sE66E5rDVf6Bd`
};
export default ___CSS_LOADER_EXPORT___;
